import { ServiceClient } from 'src/utils'
import { AnaliseRow } from './analise.types'

const serviceClient = ServiceClient.singleton()

export class AnaliseService {
    static #INSTANCE = new AnaliseService()
    static readonly singleton = () => AnaliseService.#INSTANCE

    async fetchAnaliseInfo(id: number) {
        return serviceClient.authGet<AnaliseRow>(`/api/v1/analise/${id}`)
    }

    async fetchAnalises(name?: string) {
        return serviceClient.authGet<AnaliseRow[]>(`/api/v1/analise${name ? `?name=${name}` : ''}`)
    }

    async fetchAnalisesAtivas() {
        return serviceClient.authGet<AnaliseRow[]>(`/api/v1/analise?ativos=true`)
    }

    async saveAnalise(analise: AnaliseRow) {
        const response = await serviceClient.authPost<AnaliseRow>('/api/v1/analise', analise)
        return response
    }

    async updateAnalise(idAnalise: number, analise: AnaliseRow) {
        const response = await serviceClient.authPut<AnaliseRow>(`/api/v1/analise/${idAnalise}`, analise)
        return response
    }

    async deleteAnalise(idAnalise: number) {
        const response = await serviceClient.authDelete(`/api/v1/analise/${idAnalise}`)
        return response
    }
}

export default AnaliseService.singleton()
